/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiTracksAlbumidMultiUploadMutationRequest, PostApiTracksAlbumidMultiUploadMutationResponse, PostApiTracksAlbumidMultiUploadPathParams, PostApiTracksAlbumidMultiUpload400, PostApiTracksAlbumidMultiUpload401, PostApiTracksAlbumidMultiUpload403, PostApiTracksAlbumidMultiUpload404, PostApiTracksAlbumidMultiUpload500 } from "../../types/PostApiTracksAlbumidMultiUpload.ts";
import { postApiTracksAlbumidMultiUploadMutationResponseSchema, postApiTracksAlbumidMultiUploadMutationRequestSchema } from "../../zod/TracksSchemas/postApiTracksAlbumidMultiUploadSchema.ts";

function getPostApiTracksAlbumidMultiUploadUrl({ albumId }: { albumId: PostApiTracksAlbumidMultiUploadPathParams["AlbumId"] }) {
  const res = { method: 'POST', url: `/api/tracks/${albumId}/multi-upload` as const }  
  return res
}

/**
 * @summary Мультизагрузка треков
 * {@link /api/tracks/:AlbumId/multi-upload}
 */
export async function postApiTracksAlbumidMultiUpload({ albumId, data }: { albumId: PostApiTracksAlbumidMultiUploadPathParams["AlbumId"]; data?: PostApiTracksAlbumidMultiUploadMutationRequest }, config: Partial<RequestConfig<PostApiTracksAlbumidMultiUploadMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiTracksAlbumidMultiUploadMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiTracksAlbumidMultiUploadMutationResponse, ResponseErrorConfig<PostApiTracksAlbumidMultiUpload400 | PostApiTracksAlbumidMultiUpload401 | PostApiTracksAlbumidMultiUpload403 | PostApiTracksAlbumidMultiUpload404 | PostApiTracksAlbumidMultiUpload500>, PostApiTracksAlbumidMultiUploadMutationRequest>({ method : "POST", url : getPostApiTracksAlbumidMultiUploadUrl({ albumId }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiTracksAlbumidMultiUploadMutationResponseSchema.parse(res.data)
}